import CustomMap from './CustomMap.js';

let customMap = null;

// Initialize when document is ready
$(document).ready(function () {
    if ($('#map-basic').length) {
        customMap = new CustomMap('map-basic', {
            center: [50.631900863525, 5.5643137413546],
            zoomLevel: 12,
            showZoomControls: true,
            allowZoom: false,
            useClusters: false,
            getPopupContentFunction: getPopupContent,
        });

        customMap.displayMap();

        const items = getItemsData();
        customMap.displayMarkers(items);

        handleItemClick();
        $(window).on('resize', () => customMap.fitMarkers());
    }
});

// Get items from HTML
function getItemsData() {
    const items = [];

    $('.map-item-basic').each((index, item) => {
        items.push({
            index: $(item).attr('id'),
            title: $(item).data('title'),
            address: $(item).find('span.item-address').html(),
            color: $(item).data('color'),
            lat: $(item).data('lat'),
            lng: $(item).data('lng'),
        });
    });

    return items;
}

// Generate popup content for marker
function getPopupContent(item) {
    const content = `<div class="p-4 py-3 flex flex-col text-lg gap-1 md:whitespace-nowrap bg-white">
	<p class="text-brand text-xl font-medium" style="color:${item.color}">${item.title}</p>
	<p>${item.address}</p>
	</div>`;
    return content;
}

function handleItemClick() {
    $('.map-item-basic').on('click', (e) => {
        const item = e.currentTarget;

        const lat = parseFloat($(item).data('lat'));
        const lng = parseFloat($(item).data('lng'));
        customMap.centerOnMarker([lat, lng], 12, true);
    });
}